import React, { useCallback } from "react";
import _ from "lodash";

import { FVIPDOChecklistItem } from "../../../../utils/models";

import Conditional from "../../../common/conditional";
import Select from "../../../themed/select/select";

import classNames from './style.module.scss';

interface Props {
    hasPDO: boolean;
    label: string;
    value: string;
    items: FVIPDOChecklistItem[];
    onChangeItems: (items: FVIPDOChecklistItem[]) => void;
}

const FVIPDOChecklistForm: React.FC<Props> = ({ hasPDO, label, value, items, onChangeItems }) => {
    const handleAssessmentSelect = useCallback((id: string, assessment: string) => {
        const updatedItems = items.map((item) => item.id === id ? ({ ...item, value: assessment }) : item);
        onChangeItems(updatedItems);
    }, [items, onChangeItems]);

    const renderGroupedChecklistItems = useCallback(() => {
		const groupedItems = _.groupBy(items, 'category');

		return (
			<React.Fragment>
				{Object.keys(groupedItems).map(key => {
					return (
						<Conditional key={key} isVisible={groupedItems[key].length > 0}>
							<tr>
								<td className={classNames.checklistTableCaption} colSpan={5}>
									{key}
								</td>
							</tr>
	
                            {groupedItems[key].map((item) => (
                                <tr key={item.id}>
                                    <td>{item.id}</td>
                                    <td>{item.label}</td>
                                    <td colSpan={2} className='text-center'>
                                        <Select
                                            options={CHECKLIST_OPTIONS}
                                            name="value"
                                            placeholder="Select Assessment"
                                            value={item.value}
                                            onChange={(e) => handleAssessmentSelect(item.id, e.currentTarget.value)}
                                        />
                                    </td>
                                </tr>
                            ))}
						</Conditional>
					)
				})}
			</React.Fragment>
		)
	}, [items, handleAssessmentSelect]);

    return ( 
        <table className={classNames.checklistTable}>
            <thead>
                <tr>
                    <th rowSpan={2}>
                        Item
                    </th>
                    
                    <th rowSpan={2} className={classNames.checklistTableTenderBlueBG}>
                        {label}: {value}
                    </th>
                </tr>

                <tr>
                    <th>Has PDO?</th>
                    <th>{hasPDO ? 'Yes' : 'No'}</th>
                </tr>
            </thead>

            <tbody>
                {renderGroupedChecklistItems()}
            </tbody>
        </table>
    );
};
 
const CHECKLIST_OPTIONS = [
    {
        id: 'yes',
        name: 'Yes',
    },
    {
        id: 'no',
        name: 'No',
    },
    {
        id: 'N/A',
        name: 'N/A',
    },
];

export default FVIPDOChecklistForm;